import styled from 'styled-components';
import { motion } from 'framer-motion';
import { GREEN_COLOR } from '../constants';

export const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BlogCard = styled(motion.article)`
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const BlogImage = styled.div`
  height: 180px;
  width: 100%;
  background-color: #e5e7eb;
  background-image: ${({ image }) => (image ? `url(${image})` : 'none')};
  background-size: cover;
  background-position: center;
`;

export const BlogCardContent = styled.div`
  padding: 1.75rem;
  text-align: left;
`;

export const BlogTag = styled.span`
  display: inline-block;
  color: ${GREEN_COLOR};
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
`;

export const BlogCardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
`;

export const BlogCardExcerpt = styled.p`
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.25rem;
`;

export const BlogReadMore = styled.span`
  color: #1f2937;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: underline;
`;
